import { Empty } from 'antd';
import styled from 'styled-components';

export const StyledEmpty = styled(Empty)`

`;